<template>
    <Dropdown
            :options="optionsComputed"
            :id-field="idField"
            :unique-id="uniqueId"
            :default-text="defaultText"
            :is-disable="isDisableComputed"
            :selected-id="selectedIdComputed"
            :selected-display-text-field="selectedDisplayTextField"
            @dropdownSelectedItemChanged="exportChange"
            >
    </Dropdown>
</template>

<script>
import Dropdown from 'components/dropdowns/Dropdown.vue';
import externalPropsParser from '../services/utils/externalPropsParser';
import eventBus from '../mixins/eventBus';
import externalParsedProps from '../mixins/externalParsedProps';

const parsedProps = ['options', 'isDisable', 'selectedId'];

const externalDropDownProps = {
    ...Dropdown.props,
    selectedId: {
        type: String
    }
};

export default {
    name: 'DropdownEx',
    mixins: [
        eventBus('dropdown-ex'),
        externalParsedProps(externalDropDownProps, parsedProps)
    ],
    props: externalPropsParser.setExternalProps(externalDropDownProps, parsedProps),
    methods: {
        exportChange(data) {
            this.$emit('dropdownSelectedItemChanged', data);
        }
    },
    components: { Dropdown }
};
</script>
